import React from 'react'

function TopNav() {
  return (
    <div className='tob-navbar-bg'>  New Year Sale is Live </div>
  )
}

export default TopNav